import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
import FactoryImg from "../../assets/BusBusiness/수진공장.png";
const SaleItem1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/28. 베트남 수진 부품1.35e8786cd002647c9b22.png`;
const SaleItem2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/29. 베트남 수진 부품2.589d953b1fc52334bd53.png`;
const SaleItem3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/30. 베트남 수진 부품3.e8d122af2fb885aa7ef1.png`;
const Factory2 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"상용버스사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">버스사업</div>
                <div className="eng">Bus Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
          <S.NavItem>
              <Link to="/BusBusiness/Factory">
                <div className="kor">생산공장</div>
                <div className="eng">production plant</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">해외 상용버스사업</div>
                  <div className="eng">Overseas commercial bus business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">생산공장</div>
                  <div className="eng">production plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/BusBusinessHistory">
                  <div className="kor">버스사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"312px"}>
            <S.NavItem>
              <Link to="/BusBusiness/Factory2">
                <div className="kor">베트남 부품공장</div>
                <div className="eng">Vietnam Parts Manufacturing</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">베트남 생산공장</div>
                  <div className="eng">Vietnam Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory2">
                  <div className="kor">베트남 부품공장</div>
                  <div className="eng">Vietnam Parts Manufacturing</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory3">
                  <div className="kor">중국 계림 법인</div>
                  <div className="eng">China Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory4">
                  <div className="kor">파키스탄 공장</div>
                  <div className="eng">Pakistan Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory5">
                  <div className="kor">카자흐스탄 공장</div>
                  <div className="eng">Kazakhstan Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory6">
                  <div className="kor">코스타리카 법인</div>
                  <div className="eng">Costa Rica Sales Corporation</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"베트남 수진공장"} titleeng={"Vietnam Soojin Plant "}/>
            <div className="page-text"></div>
            <S.ImgHolderFullsize>
              <img src={FactoryImg} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">수진공장</div>
                <div className="eng">Soojin Plant</div>
              </div>
            </S.ImgHolderFullsize>

            <PageTitle titleko={"주요 생산 제품"} titleeng={"Major Products"} />
            <div className="page-text"></div>
            <div className="sale-bus-list">
              <img src={SaleItem1} alt="" className="sale-vietnam-img" />
              <img src={SaleItem2} alt="" className="sale-vietnam-img" />
              <img src={SaleItem3} alt="" className="sale-vietnam-img" />
            </div>
            <div className="page-text">
              <div className="kor">
                베트남 수진 부품공장은 대형버스 부품 위주로 생산 진행중 (8개 차종
                / 1,670개 품목)
                <br /> 베트남 DH-자일 부품공장은 소형버스(레스타) 부품 위주로 생산
                예정
              </div>
              <div className="eng">
                The Vietnam Soojin parts factory primarily produces parts for large buses (8 models / 1,670 items).
                <br />
                The Vietnam DH-Zylel parts factory is scheduled to primarily produce parts for small buses (Lesta).
              </div>
            </div>

            <PageTitle titleko={"주요 이력"} titleeng={"Key Histroy"} />
            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                  <div className="kor">수진공장 개요</div>
                  <div className="eng">Soojin factory status</div>
                  </div>
                  <div className="kor">
                    생산시작: 2021년 11월 15일
                    <br />
                    <br />
                    ※ 공장규모: 수진공장 건물 2,677평 (임대)
                    <br />※ 주요 생산품목: 중대형 버스 부품
                  </div>
                  <div className="eng">
                    Start of Production: 2021. 11. 15 
                    <br />
                    ※ Factory size: building 8,900 square meters
                    <br />
                    ※ Major products: Mid & large bus parts
                  </div>
                </div>
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">DH-자일 개요</div>
                    <div className="eng">DH-Zyle status</div>
                  </div>
                  <div className="kor">
                    설립일: 2019년 6월 28일
                    <br />
                    <br />
                    ※ 공장규모: 부지 5,853평 / 건물 3,251평
                    <br />※ 주요 생산품목: 레스타 부품 생산예정
                  </div>
                  <div className="eng">
                    established: 2019. 6. 28
                    <br />
                    Factory size: land 19,300 square meters
                    <br />
                    / building 10,700 square meter
                    <br />
                    ※ Major Products: Lestar parts to be produced
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Factory2;
